<template>
  <div id="mainGraphPane">
    <vue-loaders-ball-beat v-if="isLoading"></vue-loaders-ball-beat>
    <div id="container" ref="dendroNode"></div>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import G6 from '@antv/g6';
import axios from 'axios';
// import this.$store.state.dendro_graphConfig from '../plugins/graphConfig';
import dendroConfig from '../plugins/dendroConfig';

export default {
  data() {
    return {
      gdata: {
        nodes: [
          {
            id: 'circle',
            label: 'Circle',
            // x: 250,
            // y: 150,
          },
          {
            id: 'rect',
            label: 'Rect',
            // x: 250,
            // y: 250
          },
        ],
        edges: [
          {
            source: 'circle',
            target: 'rect',
            label: 'Edge',
          },
        ],
      },
      searchWord: '',
    };
  },

  computed: {
    dendro_data() {
      return this.$store.state.dendro_graph_data;
    },
  },

  watch: {
    dendro_data(val) {
      console.log('Welcome Brother');
      this.dendro_graph.changeData(val);
      this.dendro_graph.edge((ev) => ({
        type: 'cubic-horizontal',
        color: '#A3B1BF',
        label: this.$store.state.dendro_graph_edges[`${ev.source}${ev.target}`],
      }));
    },
  },

  async mounted() {
    await this.dendroGraphBuild();
  },

  async created() {
    await this.$highway.singleDispatcher('dendroGraphAction').then(() => {
      this.dendro_graph.changeData(this.$store.state.dendro_graph_data);
    });
  },

  methods: {
    async dendroGraphBuild() {
      // const mainNode = datai.nodes[0];
      // mainNode.custom_id = mainNode.id;
      // mainNode.children = datai.nodes.slice(1, 20).map((el) => ({ ...el, custom_id: el.id }));
      // console.log(mainNode);
      // const container = document.getElementById('container');
      // const width = container.scrollWidth;
      // const height = container.scrollHeight || 500;
      const minimap = new G6.Minimap({
        size: [50, 50],
        className: 'minimap',
        type: 'delegate',
      });
      const config = dendroConfig;
      config.plugins = [minimap];
      config.container = this.$refs.dendroNode;
      this.dendro_graph = new G6.TreeGraph(config);

      this.dendro_graph.node((node) => ({
        labelCfg: {
          position:
            node.children && node.children.length > 0 ? 'left' : 'right',
          offset: 5,
          style: {
            fontSize: 15,
            fill: '#fff',
            fontWeight: 500,
            fontFamily: 'Poppins',
            color: '#fff',
          },
        },
      }));
      this.dendro_graph.on('node:click', async (node) => {
        console.log(node, 'let me check');
        console.log('current node', node.item.get('model'));
        // eslint-disable-next-line
        const eventData = { id: node.item._cfg.model.id, word: node.item._cfg.model.label };
        // console.log('eventData', eventData);
        const url = 'https://thoughtjumper.edvanta.com/api/v1/custom/snippet/graph';
        // eslint-disable-next-line
        const id  = node.item._cfg.id;
        // eslint-disable-next-line
        // console.log(id);
        // custom_id will have an accurate id of an entity
        // eslint-disable-next-line
        const params = {
          // eslint-disable-next-line
          word: node.item._cfg.model.custom_id || node.id,
          type: 'entity',
          lang: 'en',
        };
        const processNode = this.dendro_graph.findById(id);
        processNode.update({
          style: {
            fill: '#59f783',
            stroke: '#fff',
          },
        });
        const response = await axios.get(url, { params });
        console.log('Response Data', response.data);
        await this.$store.dispatch('fetchAndSetDendroExpansion', response.data);
        const dataChild = response.data.nodes.slice(1, 10).map((el) => ({
          // eslint-disable-next-line
          id: `${node.item._cfg.id}${el.id}`,
          label: el.label,
          custom_id: el.id,
        }));

        await this.dendro_graph.updateChildren(dataChild, id);
        const updatedNode = this.dendro_graph.findById(id);
        // console.log(updatedNode);
        updatedNode.update({
          style: {
            fill: '#ffc107',
            stroke: '#fff',
          },
        });
        console.log('DENDRO', this.dendro_graph.save());
        await this.$store.dispatch('setDendroData', this.dendro_graph.save());
        axios.post(`${process.env.VUE_APP_ZELDA_URI}event`, {
          actor: this.$store.state.userInfo,
          verb: 'EXPLORED',
          value: eventData,
          dataSource: 'TJ-CLIENT',
        });
      });

      // TODO - Dendro Click Event
      // this.dendro_graph.on('node:click', async (node) => {
      //   const model = node.item.get('model');
      //   console.log('Node Model', model);
      //   const data = await this.dendro_graph.save();
      //   console.log('Node Model', data);
      //   // const url = 'https://thoughtjumper.edvanta.com/api/v1/custom/snippet/graph';

      //   const params = {
      //     // eslint-disable-next-line
      //     word: model.custom_id || node.id,
      //     type: 'entity',
      //     lang: 'en',
      //   };

      //   const response = await this.$store.dispatch('fetchAndSetDendroExpansion', params);
      //   // eslint-disable-next-line
      //   const parentNodeId = node.item._cfg.parent._cfg.id;
      //   console.log('Parent Node Id', node);
      //   const finalData = this.dendro_graph.findById(parentNodeId);
      //   console.log('Final Data', finalData);
      //   const finalNode = {
      //     id: finalData._cfg.id,
      //     label: finalData._cfg.model.label,
      //     children: [response],
      //   };
      //   // finalData.children = response;
      //   const processNode = this.dendro_graph.findById(model.id);
      //   processNode.update({
      //     style: {
      //       fill: '#59f783',
      //       stroke: '#fff',
      //     },
      //   });

      //   // const response = await axios.get(url, { params });
      //   // const dataChild = response.data.nodes.slice(1, 10).map((el) => ({
      //   //   // eslint-disable-next-line
      //   //   id: `${node.item._cfg.id}${el.id}`,
      //   //   label: el.label,
      //   //   custom_id: el.id,
      //   // }));

      //   // console.log('dataChild', dataChild);
      //   // this.dendro_graph.updateChildren(dataChild, model.id);
      //   // starting data
      //   const updatedNode = this.dendro_graph.findById(model.id);
      //   console.log('dataChild - uN', updatedNode);
      //   this.$store.dispatch('setDendroData', finalNode);
      // });

      this.dendro_graph.edge((ev) => ({
        type: 'cubic-horizontal',
        color: '#A3B1BF',
        label: this.$store.state.dendro_graph_edges[`${ev.source}${ev.target}`],
      }));
      // this.dendro_graph.data(this.$store.state.dendro_graph_data);
      this.dendro_graph.render();
      this.dendro_graph.fitView();

      // if (typeof window !== 'undefined') {
      //   window.onresize = () => {
      //     if (!this.$sotre.dendro_graph || this.dendro_graph.get('destroyed')) return;
      //     if (!container || !container.scrollWidth || !container.scrollHeight) return;
      //     this.dendro_graph.changeSize(container.scrollWidth, container.scrollHeight);
      //   };
      // }
    },
    async changeGraph(search) {
      // console.log('search', search);
      const params = {
        word: search,
        type: 'string',
        lang: 'en',
        graph_type: 'dendro',
      };
      await this.$store.dispatch('wikiGraphAction', params).then(() => {
        // console.log(this.$store.state.dendro_graph_data);
        this.dendro_graph.changeData(
          this.$store.state.dendro_graph_data,
        );
        this.dendro_graph.render();
      });
    },
  },
};
</script>

<style scoped>
div {
  font-family: "Helvetica", sans-serif;
}
#container {
  width: 85.3125em;
  height: 88vh;
  position: relative;
}
#mainGraphPane {
  background: #576f7f;
}
</style>
